"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClientSessionManager = void 0;
const lodash_1 = __importDefault(require("lodash"));
const constants_1 = require("./constants");
const createClientSessionManager = (config) => {
    // TODO figure out what to do with logger and sessionProvider
    // until then we receive it from thunderbolt IOC from `LoggerSymbol`, `SessionProviderSymbol` symbols
    const logger = config.logger;
    const sessionProvider = config.sessionProvider;
    const window = globalThis.window;
    let sessionTimeoutPointer;
    const isRunningInDifferentSiteContext = config.isRunningInDifferentSiteContext;
    const onLoadSessionCallbacks = new Set();
    const addLoadNewSessionCallback = (callback) => {
        onLoadSessionCallbacks.add(callback);
        return () => onLoadSessionCallbacks.delete(callback);
    };
    const invokeSessionLoadCallbacks = (reason) => {
        const { apps, siteMemberId, visitorId, svSession, smToken } = sessionModel;
        const instances = lodash_1.default.mapValues(apps, 'instance');
        onLoadSessionCallbacks.forEach(callback => {
            callback({
                results: { instances, siteMemberId, visitorId, svSession, smToken },
                reason,
            });
        });
    };
    const sessionModel = Object.assign(config.sessionModel, sessionProvider ? sessionProvider.getCurrentSession() : {});
    const metaSiteAppId = sessionModel.apps?.[constants_1.METASITE_APP_DEF_ID];
    if (metaSiteAppId) {
        logger?.updateApplicationsMetaSite(metaSiteAppId.instance);
    }
    invokeSessionLoadCallbacks('firstLoad');
    const getAllInstances = () => {
        return sessionModel.apps || {};
    };
    const getAppInstanceByAppDefId = (appDefId) => {
        return getAllInstances()[appDefId]?.instance;
    };
    const loadNewSession = async (options = { reason: 'noSpecificReason' }) => {
        try {
            const newSession = await sessionProvider?.loadNewSession(options);
            Object.assign(sessionModel, newSession);
            invokeSessionLoadCallbacks(options.reason);
        }
        catch (error) {
            logger?.captureError(new Error(`failed loading new session`), {
                tags: { feature: 'session-manager' },
                extra: { errorMessage: error.message },
            });
        }
        setNextSessionRefresh();
    };
    const setNextSessionRefresh = () => {
        if (!isRunningInDifferentSiteContext) {
            setSessionTimeout();
        }
    };
    const setSessionTimeout = () => {
        if (sessionTimeoutPointer) {
            window.clearTimeout(sessionTimeoutPointer);
        }
        sessionTimeoutPointer = window.setTimeout(() => loadNewSession({ reason: 'expiry' }), config.expiryTimeoutOverride || constants_1.DEFAULT_EXPIRATION_TIME);
    };
    // set initial timeout / message registrar for refresh
    setNextSessionRefresh();
    return {
        getAllInstances,
        getAppInstanceByAppDefId,
        getSiteMemberId() {
            return sessionModel.siteMemberId;
        },
        getSmToken() {
            return sessionModel.smToken;
        },
        getVisitorId() {
            return sessionModel.visitorId;
        },
        addLoadNewSessionCallback,
        getHubSecurityToken() {
            return String(sessionModel.hs || 'NO_HS');
        },
        getUserSession() {
            return sessionModel.svSession;
        },
        getCtToken() {
            return sessionModel.ctToken;
        },
        setUserSession(svSession) {
            sessionModel.svSession = svSession;
        },
        loadNewSession,
        getContactId() {
            return sessionModel.contactId;
        },
    };
};
exports.createClientSessionManager = createClientSessionManager;
//# sourceMappingURL=clientSessionManager.js.map